// extracted by mini-css-extract-plugin
module.exports = {"container":"WishList_container__ATjiA"};